import {Image, Logo} from 'exsportia-components'
import {TextType} from 'exsportia-components/dist/types'
import {useMemo} from 'react'
import {useQuery} from 'react-query'

import {AreaQueries} from '../../../api/area'
import {PlayspaceCard} from '../../../components/playspace-card/playspace-card'
import {PLACEMENT_MAP} from '../../../constants/area-settings'
import {LabeledSection} from '../../../ui/components/labeled-section/labeled-section'
import {useLocale} from '../../../utils/i18n'

export const AreaSection = ({areaId}: {areaId: string}) => {
  const {l} = useLocale()
  const {data: area, isLoading: isAreaLoading} = useQuery(
    AreaQueries.getAreaQuery({params: {id: areaId}}),
  )
  const placeSubtext = useMemo(() => {
    const subtext: TextType[] = area?.surfaceType ? [l(area.surfaceType)] : []
    if (area?.areaSize) {
      subtext.push(
        <span>
          {area.areaSize} m<sup>2</sup>
        </span>,
      )
    }
    if (area?.placement) {
      subtext.push(l(PLACEMENT_MAP[area.placement]))
    }
    return subtext
}, [area, l])
  return (
    <LabeledSection label={l('playSpace')}>
      <PlayspaceCard
        name={area?.name}
        styleType={'square'}
        isLoading={isAreaLoading}
        subTextElements={placeSubtext}
        image={
          <Logo
            smallLogo={
              <Image
                height={'48px'}
                width={'72px'}
                size={'contain'}
                src={area?.media?.[0]?.secure_url}
              />
            }
            forceUse={'small'}
          />
        }
      />
    </LabeledSection>
  )
}


